import React from "react";
import { ContactUsGuideCheck, ContactUsGuideText } from "./style";
import CheckIcon from "@/assets/img/ic_check.svg";

interface ContactUsGuideTextProps {
	children: React.ReactNode;
	last?: boolean;
}

export const ContactUsGuideItem = ({ children, last }: ContactUsGuideTextProps) => {
	return (
		<ContactUsGuideText last={last}>
			<ContactUsGuideCheck>
				<img src={CheckIcon} alt="check icon" />
			</ContactUsGuideCheck>
			{children}
		</ContactUsGuideText>
	);
};
